import React, { useCallback, useState } from 'react'
import { Box, ImageLoader } from '@usap/uicomponents'

export default function Image({
  fit,
  layout,
  height,
  width,
  alt,
  src,
  isBot,
}) {
  const [isHovering, setIsHovering] = useState(false)

  const handleMouseHover = useCallback(
    () => {
      const hovering = isHovering
      setIsHovering(!hovering)
    },
    [isHovering],
  )

  return (
    <Box
      className="image-container-po"
      onMouseEnter={handleMouseHover}
      onMouseLeave={handleMouseHover}
      animation={
        isHovering
          ? {
            type: 'zoomIn', duration: 300, delay: 600, size: 'medium',
          }
          : {}
      }
    >
      <ImageLoader
        fit={fit}
        layout={layout}
        height={height}
        width={width}
        alt={alt}
        isBot={isBot}
        src={src}
      />
    </Box>
  )
}
